export default "__VITE_ASSET__CAJ61YVO__"